import Calendar from "./Calendar";
import "react-calendar/dist/Calendar.css";

function App() {
  return (
    <div className="App">
      <header>
        <h1>그저 달력 📆</h1>
      </header>
      <Calendar />
    </div>
  );
}

export default App;
